import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewCategoriesQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewCategoriesQuery = { __typename?: 'query_root', plan_review_categories: Array<{ __typename?: 'plan_review_categories', id: any, code: string, name: string, ai_guidance?: string | null, sort_order: number }> };


export const GetPlanReviewCategoriesDocument = gql`
    query getPlanReviewCategories($jurisdictionId: uuid!) {
  plan_review_categories(
    where: {active: {_eq: true}, jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: [{sort_order: asc}, {name: asc}]
  ) {
    id
    code
    name
    ai_guidance
    sort_order
  }
}
    `;

/**
 * __useGetPlanReviewCategoriesQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewCategoriesQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables> & ({ variables: GetPlanReviewCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>(GetPlanReviewCategoriesDocument, options);
      }
export function useGetPlanReviewCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>(GetPlanReviewCategoriesDocument, options);
        }
export function useGetPlanReviewCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>(GetPlanReviewCategoriesDocument, options);
        }
export type GetPlanReviewCategoriesQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesQuery>;
export type GetPlanReviewCategoriesLazyQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesLazyQuery>;
export type GetPlanReviewCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesSuspenseQuery>;
export type GetPlanReviewCategoriesQueryResult = Apollo.QueryResult<GetPlanReviewCategoriesQuery, GetPlanReviewCategoriesQueryVariables>;